module.exports = __webpack_public_path__ + "media/music/punchy_bass_5-e3573699.mp3";